<template>
<div class="join-page">
  <div class="banner"></div>
  <div class="job-container">
    <div class="job-box">
      <div class="title">{{$t('message.filter')}}</div>
      <div class="line"></div>
      <!-- 岗位类型 -->
      <div class="type common">
        <div class="tit">{{$t('message.position')}}</div>
        <div class="type-list list">
          <div
            v-for="item in jobTitleList"
            :key="item.title"
            @click="jobTitleChoose(item.title)"
            class='item'
            :style="{
              backgroundColor: jobTitle === item.title ? '#2F78B1' : '',
              color: jobTitle === item.title ? '#fff' : ''
            }"
          >
            {{item.title}}
          </div>
        </div>
      </div>
      <!-- 工作地点 -->
      <div class="location common">
        <div class="tit">{{$t('message.location')}}</div>
        <div class="list">
          <div
            v-for="item in locationList"
            :key="item.title"
            @click="locationChoose(item.title)"
            class="item"
            :style="{
              backgroundColor: location === item.title ? '#2F78B1' : '',
              color: location === item.title ? '#fff' : ''
            }"
          >
            {{item.title}}
          </div>
        </div>
      </div>
      <!-- 职位性质 -->
      <div class="nature common">
        <div class="tit">{{$t('message.nature')}}</div>
        <div class="list">
          <div
            v-for="item in natureList"
            :key="item.title"
            @click="jobTypeChoose(item.title)"
            class="item"
            :style="{
              backgroundColor: jobType === item.title ? '#2F78B1' : '',
              color: jobType === item.title ? '#fff' : ''
            }"
          >
            {{item.title}}
          </div>
        </div>
      </div>

      <div v-if="jobList.length">
        <div class="line"></div>
        <div class="job-list" v-if="jobList.length">
        <div class="job-item" v-for="item in jobList" :key="item.id" @click="goDetail(item.id)">
          <div class="item-top">
            <div class="position">{{item.name}}</div>
            <div class="loc-people-num">
              <div class="loc">
                <img class="loc-img" src="https://oss.turingsenseai.com/1598936853441450214.png">
                <div class="common-text">{{item.location}}</div>
              </div>
              <div class="people-num">
                <img class="people-num-img" src="https://oss.turingsenseai.com/1598401118748020926.png">
                <div class="common-text">{{item.headCount}}人</div>
              </div>
            </div>
            <div class="release-time">发布时间：{{item.createTime}}</div>
          </div>
          <div class="item-btm">
            <div class="desc">{{item.title}} | {{item.jobType}} | {{item.experience}}</div>
            <div class="salary">{{item.salary}}</div>
          </div>
        </div>
      </div>
        <!-- 分页 -->
        <div class="pagation-container-join">
          <el-pagination
            layout="prev, pager, next"
            :page-size="pageSize"
            :total="totalCount"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>

      <!-- 暂无数据兜底 -->
      <div v-else>
        <div class="line"></div>
        <div style="padding: 60px;padding-bottom: 80px;">
          <div style="padding-top: 50px;padding-bottom: 16px">
            <img style="width: 60px; height: 64px" src="https://oss.turingsenseai.com/1599023952744789219.png" alt="">
          </div>
          <div style="font-size: 16px; color: #202731; padding-bottom: 70px">暂无招聘信息哦</div>
        </div>
      </div>

    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue'
import { list, getJobList } from 'api/join'
export default {
  components: {},
  created () {
    this.getTypeList()
    this.getJobListApi()
  },
  mounted () {
    this.$i18n.locale === 'zh' ? this.language = 0 : this.language = 1 // 数据加载时判断当前属于哪种语言，为其单选按钮赋值
  },
  data () {
    return {
      language: 0,
      jobTitleList: [
        { title: '全部' }
      ],
      lang: [{
        label: this.$t('message.zh'), // 模板语法的一种
        value: 0
      }, {
        label: this.$t('message.en'),
        value: 1
      }],
      jobTitle: '全部', // 岗位类型
      location: '全部', // 工作地点
      jobType: '全部', // 职位性质
      jobList: [],
      locationList: [
        { title: '全部' },
        { title: '南京' },
        { title: '北京' },
        { title: '苏州' },
        { title: '上海' },
        { title: '肇庆' },
        { title: '其他' }
      ],
      natureList: [
        { title: '全部' },
        { title: '全职' },
        { title: '兼职' },
        { title: '实习' },
        { title: '校招' }
      ],
      pageSize: 9,
      totalCount: 0
    }
  },
  watch: { // 侦听器
    language: function (val) { // 侦听单选按钮的变化，从而进行切换语言
      val === 0 ? this.$i18n.locale = 'zh' : this.$i18n.locale = 'en'
      Vue.set(this.lang, 0, { label: this.$t('message.zh'), value: 0 })
      Vue.set(this.lang, 1, { label: this.$t('message.en'), value: 1 })
    }
  },
  methods: {
    goDetail (id) {
      this.$router.push('join/detail/' + id)
      // this.$router.push({ name: 'Detail', params: { id } })
    },
    // 初始化 获取岗位类型
    async getTypeList () {
      list({
        pageNum: 1,
        pageSize: 99,
        status: 1
      }).then(res => {
        if (res.errorMsg === 'Success') {
          this.jobTitleList = this.jobTitleList.concat(res.jobTitleList)
        } else {
          // todo
        }
      })
    },
    jobTitleChoose (e) {
      if (this.jobTitle === e) {
        return
      } else {
        this.jobTitle = e
      }
      this.getJobListApi()
    },
    locationChoose (e) {
      if (this.location === e) {
        return
      } else {
        this.location = e
      }
      this.getJobListApi()
    },
    jobTypeChoose (e) {
      if (this.jobType === e) {
        return
      } else {
        this.jobType = e
      }
      this.getJobListApi()
    },
    getJobListApi (page = 1) {
      getJobList({
        pageNum: page,
        pageSize: this.pageSize,
        jobTitle: this.jobTitle === '全部' ? '' : this.jobTitle,
        location: this.location === '全部' ? '' : this.location,
        jobType: this.jobType === '全部' ? '' : this.jobType
      }).then(res => {
        if (res.errorMsg === 'Success') {
          if (res.jobList.length) {
            this.jobList = res.jobList
            this.totalCount = res.totalCount
          } else {
            this.jobList = []
          }
        } else {
          // todo
        }
      })
    },
    // 分页切换
    handleCurrentChange (e) {
      this.currentPage = e
      this.getJobListApi(this.currentPage)
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './index.scss';
</style>
